import React from "react";
import FacebookIcon from "../../../Assets/facebook.svg";
import XIcon from "../../../Assets/X.svg";
import InstagramIcon from "../../../Assets/insta.svg";
import LinkedInIcon from "../../../Assets/linkedin.svg";
import "./style.scss";
const JoinTribe = () => {
  return (
    <div className="joinTribe staticContent">
      <p>
        Follow us on your favorite platforms for the latest updates, tips, and
        inspiration.
      </p>
      <h1>Join the Student Tribe Community!</h1>
      <p className="join-line-component">
        <span>Dive Deeper!</span> Connect with us on Linkedin, Instagram and
        Facebook for the latest buzz, insider tips & more.
      </p>
      <p className="join-line-component">
        <span>Join the Crew!</span> Engage, ask, share on our student tribe app.
        Be part of our vibrant community.
      </p>
      <p className="join-line-component">
        <span>Be in the Know!</span> New Opportunities? Exclusive events? Follow
        us and be the first.
      </p>
      <div className="link-icons">
        <a href="https://facebook.com/stumagz" target="_blank" rel="noreferrer">
          <img src={FacebookIcon} alt="facebook" />
        </a>
        <a href="https://linkedin.com/stumagz" target="_blank" rel="noreferrer">
          <img src={LinkedInIcon} alt="linkedin" />
        </a>
        <a
          href="https://instagram.com/stumagz"
          target="_blank"
          rel="noreferrer"
        >
          <img src={InstagramIcon} alt="instagram" />
        </a>
        <a href="https://x.com/Stumagz" target="_blank" rel="noreferrer">
          <img src={XIcon} alt="X" />
        </a>
      </div>
    </div>
  );
};

export default JoinTribe;
